


import React, { useState } from "react";
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import DietPlanQuestionnaireDetails from "./DietPlanQuestionnaireDetails";
import DietPlanQuestionnaire from "./DietPlanQuestionnaire";
import AllDietPlanQuestionnaire from "./AllDietPlanQuestionnaire";



const DietPlanQuestionnaireTabs = () => {
  const [tabs, setTabs] = useState([{ label: "All Diet Forms", component: "allBenefits" },{ label: "+ Add Diet Forms", component: "addBenefits" }]);
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to Add a New Warehouse Tab
  const handleAddTab = (exercise) => {
    const existingTab = tabs.find((tab) => tab.id === exercise.id);
    if (!existingTab) {
      setTabs([...tabs, { id: exercise.id, label: exercise.benefit_name, component: "benefitsDetails", data: exercise }]);
      setSelectedTab(tabs.length);
    } else {
      setSelectedTab(tabs.findIndex((tab) => tab.id === exercise.id));
    }
  };

  const handleCloseTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    
    if (index === selectedTab) {
      if (newTabs.length > 2) {
        setSelectedTab(Math.max(0, index - 1)); // Move to previous tab if available
      } else {
        setSelectedTab(0); // Reset to "All Exercises" if only default tabs remain
      }
    }
  
    setTabs(newTabs);
  };
  
  return (
    <Box sx={{ width: "100%" }}>
      {/* MUI Tabs */}
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{tab.label}</Typography>
                {index > 1 && (
                  <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ ml: 1 }}>
                    <Close fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {tabs[selectedTab].component === "allBenefits" && <AllDietPlanQuestionnaire onExerciseClick={handleAddTab} />}
        {tabs[selectedTab].component === "addBenefits" && <DietPlanQuestionnaire/>}
        {tabs[selectedTab].component === "benefitsDetails" && <DietPlanQuestionnaireDetails benefits={tabs[selectedTab].data} />}
      </Box>
    </Box>
  );
};

export default DietPlanQuestionnaireTabs;
